import * as z from "zod";
import { hotelUpdateSchema } from "@/components/pages/hotels/utils/hotelSchema";
import {
  isValidTimezone,
  normalizeTimezone,
} from "@/components/pages/general-info/utils/generalInfoOptions";

const TIME_REGEX = /^([0-1]?\d|2[0-3]):00$/;

const optionalUrlField = z
  .union([z.literal(""), z.string().trim().url("Must be a valid URL")])
  .optional();

export const generalInfoSchema = hotelUpdateSchema.extend({
  timezone: z
    .string()
    .trim()
    .nonempty("Timezone is required")
    .transform(normalizeTimezone)
    .refine(
      isValidTimezone,
      "Select a valid IANA time zone, e.g. Europe/Madrid",
    ),
  website: z
    .string()
    .trim()
    .nonempty("Website is required")
    .url("Must be a valid URL")
    .refine((value) => value.startsWith("https://"), {
      message: "Website must start with https://",
    }),
  checkInTime: z
    .string()
    .trim()
    .nonempty("Check-in time is required")
    .regex(TIME_REGEX, "Invalid time format"),
  checkOutTime: z
    .string()
    .trim()
    .nonempty("Check-out time is required")
    .regex(TIME_REGEX, "Invalid time format"),
  description: z
    .string()
    .max(2000, "Description must be at most 2000 characters")
    .nullable()
    .optional(),
  socialMediaInstagram: optionalUrlField,
  socialMediaFacebook: optionalUrlField,
  socialMediaOther: optionalUrlField,
});

export type GeneralInfoFormData = z.infer<typeof generalInfoSchema>;
